import ITheme from "@/interfaces/iTheme";
import backgroundImage from "@assets/themes/loveBytes/loveBytesBackgroundImage.svg";

export class LoveBytesTheme implements ITheme
{
    static Id = 'lovebytes';
    id = LoveBytesTheme.Id;

    name = 'Love Bytes';

    colors = {
                application: '#8C1B24',
                text: '#E0E0E0',
                confirm: '#BF2A37',
                secondary: '#62B4E4',

                // Challenge card colors
                solved: '#321659',
                unsolved: '#CECECE',
                unsolvedText: '#000',
                noMoreAttempts: '#BF2A37',
                locked: '#BF2A37',
                disabled: '#BF2A37',

                windowBackground: '#0009',
                windowText: '#FFF',
                windowBorder: '#FFFFFF1F',

                tag: '#62B4E4',
                activeTab: '#62B4E4',
                dialogHeader: '#BF2A37',
                dialogHeaderText: '#FFF',
                dialogText: '#303030',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#553A97',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: 'white',
                tableHeaderSelectAllButtons: '#62B4E4',

                //settings and bulk select checkboxes 
                checkedFill: '#8C1B24',
                settingsInputError: '#DF4343',
                settingsInputErrorShadow: '#290304',

                // focus indicators
                focusVisibleIndicator:  '#8C1B24',

                // the most common color from the background image with sufficient contrast
                backgroundImageColor: '#190301',

                actionButtonBackground: '#190301',
                actionButtonText: 'white',
             };
        
    fontFamily = "Blinker";
    landingFontFamily = "Jersey15";
    backgroundImage = backgroundImage;
    isDark = true;
}

